import { IPromo } from '../../types/newbuilding/promos';
import { IApplicationState } from '../../types/redux';
import { getPromos } from './getPromos';

export function getPromo(state: IApplicationState): IPromo | undefined {
  return getPromos(state)[0];
}
